'use client';

import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { ROUTES } from 'src/constants/routes';
import useRouteWithParams from 'src/hooks/useRouteWithParams';
import { PromoBanner } from 'src/components/Molecules/PromoBanner';
import useTranslations from 'src/hooks/useTranslations';
const BookAMeetingBanner: React.FC = () => {
  const $ = _c(18);
  const {
    t
  } = useTranslations();
  const router = useRouter();
  const {
    updatePathWithParams
  } = useRouteWithParams();
  let t0;
  if ($[0] !== updatePathWithParams) {
    t0 = updatePathWithParams(ROUTES.BOOK_A_MEETING);
    $[0] = updatePathWithParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const bookAMeetingRoute = t0;
  let t1;
  let t2;
  if ($[2] !== t) {
    t1 = () => <Image src="/images/avatar-with-status.png" alt={t("common.bookMeeting")} width={44} height={48} />;
    t2 = t("components.bookMeetingBanner.title");
    $[2] = t;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("components.bookMeetingBanner.description");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("components.bookMeetingBanner.button");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== bookAMeetingRoute || $[10] !== router) {
    t5 = () => router.push(bookAMeetingRoute);
    $[9] = bookAMeetingRoute;
    $[10] = router;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t1 || $[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== t5) {
    t6 = <><PromoBanner image={t1} title={t2} description={t3} buttonText={t4} buttonStartIcon={EventAvailableIcon} onButtonClick={t5} /></>;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};
export default BookAMeetingBanner;